import React, {useState, useEffect, useRef} from 'react';
import "./style/style.css";
import {useHistory, useLocation} from 'react-router-dom';
import {
    Typography,
    Upload,
    Image,
    Select,
    message,
    Collapse,
    Space, Button,
    Form,
    Input,
    Spin, Alert, Row,
    Col, Card, Divider, Pagination
} from 'antd';
import {
    LoadingOutlined,
    PlusOutlined,
    PlaySquareOutlined,
    FilePdfOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    CheckCircleTwoTone,
} from '@ant-design/icons';
import {Modal} from 'antd';
import smmileApi from "services/smmile";
import Cookies from 'js-cookie';

const {Title} = Typography;
const {Panel} = Collapse;
const {TextArea} = Input;
const {Option} = Select;
const {Text, Link} = Typography;

const loadingOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 1000, // Ensure it covers other content
};


const generateInitialPanel = (key) => ({
    key: key.toString(),
    base64_string: '',
    question: '',
    answer: '',
    url: '',
    loading: false,
    formKey: new Date().getTime(),
});

const tutorial_video = <iframe width="560" height="315"
                               src="https://www.youtube.com/embed/ADtl_872p70?si=pPGWBn4ZNc_axWlK"
                               title="YouTube video player" frameBorder="0"
                               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                               referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
const SMMILE = () => {
    const [panels, setPanels] = useState([generateInitialPanel(1)]);
    const [activePanelKeys, setActivePanelKeys] = useState(['1']);

    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [selectedSpecialty, setSelectedSpecialty] = useState('');
    const [openModelInstruction, setopenModalInstruction] = useState(false);
    const [openModalTutorial, setopenModalTutorial] = useState(false);
    const [openModalValidation, setopenModalValidation] = useState(false);
    const [openModalSuccess, setOpenModalSuccess] = useState(false);
    const [isBackendLoading, setIsBackendLoading] = useState(false);
    const [problemId, setProblemId] = useState(null);


    const [username, setUsername] = useState('');
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const location = useLocation(); // Hook from react-router-dom
    const history = useHistory();

    const [formSpecialty] = Form.useForm();


    useEffect(() => {
        const fetchData = async () => {
            try {
                const urlParams = new URLSearchParams(location.search);
                const urlUsername = urlParams.get('username');
                const problemID = urlParams.get('key');

                const savedUsername = urlUsername || Cookies.get('username');
                const savedProblemId = problemID || null;

                if (savedUsername) {
                    setUsername(savedUsername);
                    setProblemId(savedProblemId);
                    setIsFormSubmitted(true); // Assume form submission if a username is already saved
                }

                if (savedProblemId !== null) {
                    setIsBackendLoading(true)
                    const response = await smmileApi.retrieveAnnotation(savedProblemId);
                    setIsBackendLoading(false)
                    console.log('Annotation retrieved:', response);

                    const retrievedPanels = response.response; // Adjust this based on your actual response structure

                    // Map over the retrievedPanels to set any missing fields
                    const processedPanels = retrievedPanels.map((panel, index) => ({
                        ...panel,
                        key: panel.key ? panel.key.toString() : (index + 1).toString(),
                        loading: false,
                        formKey: new Date().getTime() + index,
                        base64_string: '', // We'll fetch this next
                    }));

                    // Set activePanelKeys
                    setActivePanelKeys(processedPanels.map(panel => panel.key));

                    // Now fetch base64_string for each panel
                    const panelsWithBase64 = await Promise.all(
                        processedPanels.map(async (panel) => {
                            const base64_string = await fetchBase64FromURL(decodeURIComponent(panel.url));
                            return {
                                ...panel,
                                base64_string: base64_string || '',
                            };
                        })
                    );

                    setPanels(panelsWithBase64);

                    // Set selectedSpecialty if available
                    if (response.speciality) {
                        console.log(response.speciality)
                        setSelectedSpecialty(response.speciality);
                        formSpecialty.setFieldsValue({medical_speciality: response.speciality});
                    }
                }

            } catch (error) {
                console.error('Error fetching data:', error);
                // Optionally, handle the error state here
            }
        };

        fetchData();
    }, [location]); // React to changes in location

    const fetchBase64FromURL = async (url) => {
        // URL of your server-side proxy endpoint
        const API_URI = process.env.REACT_APP_API_URI;
        const proxyUrl = `${API_URI}/misc/smmile/fetch-image?url=${encodeURIComponent(url)}`;

        try {
            const response = await fetch(proxyUrl);
            const blob = await response.blob();
            const reader = new FileReader();

            return new Promise((resolve, reject) => {
                reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            message.error('Error fetching URL through proxy:', error);
            return null;
        }
    };


    const handleSpecialtyChange = (value) => {
        setSelectedSpecialty(value);
    };

    const handleUsernameFormSubmit = (e) => {
        e.preventDefault(); // Prevent the form from causing a page reload
        if (username.trim()) { // Simple validation to check if the username isn't empty
            Cookies.set('username', username, {expires: 1}); // Set a cookie for 7 days
            setIsFormSubmitted(true);
        } else {
            message.error('Please enter a username.');
        }
    };


    const addPanel = () => {
        const newKey = `${panels.length + 1}`;
        const newPanel = generateInitialPanel(newKey); // Generate a fresh panel
        setPanels(panels.concat(newPanel)); // Add the new panel
        setActivePanelKeys(activePanelKeys.concat(newKey)); // Update active panel keys
    };

    const handleDeletePanel = (key) => {
        if (panels.length === 1) {
            handleReset()
        } else {
            // Filter out the panel to be deleted
            const updatedPanels = panels.filter(panel => panel.key !== key);
            setPanels(updatedPanels);

            // Update activePanelKeys, remove if it's the one being deleted
            const updatedActivePanelKeys = activePanelKeys.filter(activeKey => activeKey !== key);
            setActivePanelKeys(updatedActivePanelKeys);

            // Optionally, adjust the preview state if needed
            if (previewImage && updatedPanels.findIndex(panel => panel.base64_string === previewImage) === -1) {
                setPreviewVisible(false);
                setPreviewImage('');
            }
        }
    };

    const handleReset = () => {
        setPanels([generateInitialPanel(1)]);
        setActivePanelKeys(['1']);
        setPreviewVisible(false);
        setPreviewImage('');
        setSelectedSpecialty('');
        formSpecialty.resetFields(['medical_speciality']);
        setIsBackendLoading(false)

    };


    const handleUploadChange = (info, index) => {
        // Assuming the last file in fileList is the one we're interested in
        const latestFile = info.fileList[info.fileList.length - 1];
        // Check if we have an originFileObj to work with
        if (latestFile.originFileObj) {
            // Indicate loading
            const newPanels = [...panels];
            newPanels[index].loading = true;
            setPanels(newPanels);

            // Convert the originFileObj to a base64 string
            getBase64(latestFile.originFileObj, base64_string => {
                // Update panel with the image URL and stop loading
                const updatedPanels = [...panels];
                updatedPanels[index].base64_string = base64_string;
                updatedPanels[index].loading = false;
                setPanels(updatedPanels);
            });
        }
    };

    const getBase64 = (file, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(file);
    };

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must be smaller than 2MB!');
            return Upload.LIST_IGNORE;
        }
        return false; // Prevents default upload
    };

    const movePanel = (direction) => (key) => {
        setPanels((currentPanels) => {
            const index = currentPanels.findIndex(panel => panel.key === key);
            if (index < 0) return currentPanels; // Key not found, no change

            const newIndex = index + (direction === 'up' ? -1 : 1);
            // Check bounds
            if (newIndex < 0 || newIndex === currentPanels.length) return currentPanels;

            // Clone the array and swap
            const newPanels = [...currentPanels];
            [newPanels[index], newPanels[newIndex]] = [newPanels[newIndex], newPanels[index]];
            return newPanels;
        });
    };

    const movePanelUp = movePanel('up');
    const movePanelDown = movePanel('down');

    const handleSubmitPre = () => {
        // Check for empty fields in each panel
        let emptyFieldDetails = [];

        if (!selectedSpecialty)
            emptyFieldDetails.push(`Medical specialties is empty.`);

        panels.forEach((panel, index) => {
            if (!panel.question) {
                emptyFieldDetails.push(`Panel ${index + 1}: Question is empty.`);
            }

            if (!panel.url) {
                emptyFieldDetails.push(`Panel ${index + 1}: URL is empty.`);
            }
            if (!panel.answer) {
                emptyFieldDetails.push(`Panel ${index + 1}: Answer is empty.`);
            }
            if (!panel.base64_string) {
                emptyFieldDetails.push(`Panel ${index + 1}: Image url is not uploaded.`);
            }
        });


        // Notify the user if any field is empty
        if (emptyFieldDetails.length > 0) {
            message.error(
                <>
                    <p>Please fill in all fields before submitting.</p>
                    <p>Check the following:</p>
                    <ul>
                        {emptyFieldDetails.map((name) => (
                            <li key={name}>{name}</li>
                        ))}
                    </ul>
                </>
            );
            return; // Stop the submission process
        }

        if (panels.length <= 2) {
            message.error('You need at least three panels');
            return; // Stop the submission process
        }

        if (!username) {
            message.error('No username, something is very wrong. Refresh page.');
            return; // Stop the submission process
        }
        console.log(panels)
        setopenModalValidation(true)
    }
    const handleSubmit = async () => {
        setopenModalValidation(false);

        // Removing the base64_string key from all panels
        let new_panels = panels.map(({base64_string, ...panel}) => panel);

        console.log(problemId);

        setIsBackendLoading(true);

        const response = await smmileApi.saveAnnotations(new_panels, selectedSpecialty, username, problemId);

        setIsBackendLoading(false);

        if (response.save) {
            setOpenModalSuccess(true);
        } else {
            // Show error message if save failed
            message.error(response.error || 'Failed to save annotations.');
        }
    };


    const updateField = (index, field, value) => {
        const newPanels = [...panels];
        newPanels[index][field] = value;
        setPanels(newPanels);
    };

    const updateFieldURL = async (index, field, value) => {
        updateField(index, field, encodeURIComponent(value));

        // URL of your server-side proxy endpoint
        const API_URI = process.env.REACT_APP_API_URI
        const proxyUrl = `${API_URI}/misc/smmile/fetch-image?url=${encodeURIComponent(value)}`;

        try {
            const response = await fetch(proxyUrl);
            const blob = await response.blob();
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64data = reader.result;
                const updatedPanels = [...panels];
                updatedPanels[index].base64_string = base64data;
                updatedPanels[index].loading = false;
                setPanels(updatedPanels);
            };

            reader.readAsDataURL(blob);
        } catch (error) {
            message.error('Error fetching URL through proxy:', error);
        }
    };
    const handleDeleteImage = (index) => {
        const newPanels = [...panels];
        newPanels[index].base64_string = '';
        setPanels(newPanels);
    };

    const handlePreviewImage = (base64_string) => {
        setPreviewImage(base64_string);
        setPreviewVisible(true);
    };

    const uploadButton = (loading) => (
        <div>
            {loading ? <LoadingOutlined/> : <PlusOutlined/>}
            <div style={{marginTop: 8}}>Upload</div>
        </div>
    );
    return (
        <div>
            {!isFormSubmitted ? (
                <form onSubmit={handleUsernameFormSubmit} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: 50,
                }}>
                    <Title style={{marginBottom: '20px', fontWeight: 900, fontSize: '68px'}}>SMMILE</Title>
                    <div align={"left"} style={{width: 900}}>
                        <>
                            <h1 style={{marginBottom: '10px', fontWeight: 500, fontSize: '34px'}}>
                                Stanford Multimodal Medical In-context Learning benchmark (😊SMMILE)
                            </h1>

                            <p style={{marginBottom: '16px'}}>
                                <strong>Contact:</strong> Michael Moor, MD PhD (mdmoor@cs.stanford.edu), Jean-Benoit
                                Delbrouck, PhD (jbdel@stanford.edu)
                            </p>

                            <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                We're excited that you are participating in this Stanford CS / AIMI research project
                                to create a medical visual question-answering (VQA) benchmark for multimodal AI models!
                                We focus on challenging
                                tasks for which we provide a model with few multimodal context examples, to be followed
                                by a final problem (see
                                below in the visual examples) which on its own is not easy to solve for existing
                                vision-language models (i.e.,
                                those of us with access can check with GPT4-V).
                            </p>

                            <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                <strong>Topics:</strong> The problems can range across all medical specialties,
                                including
                                radiology images, photographs, pathology slices, ophthalmology imaging etc. Try to focus
                                mostly on 2D images (e.g.,
                                slice of CT, Chest X-ray, Photograph etc.), but links to further modalities are welcome
                                (audio, video,
                                sequencing etc.) - as long as they can be referred to via URL.
                            </p>

                            <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                <strong>Data:</strong> Do NOT upload any media (e.g., images, videos, audio). Instead,
                                please
                                provide a URL (link) to a publicly available media resource. Do not display any
                                identifiable patient
                                information.
                            </p>

                            <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                <strong>Guidelines:</strong> Try to follow a consistent answer format within a given
                                problem - if
                                the problem allows for it. Most importantly, answers must follow a consistent format:
                                "Epidural hematoma,
                                left.", "Subdural hematoma, right." etc. <strong>Two in-context examples minimum - 10
                                maximum.</strong>
                            </p>

                            <h2 style={{fontWeight: 'bold', marginTop: '20px'}}>Example Problems</h2>
                            <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                Here are four examples of how the in-context learning problems can look. These problems
                                are considered well formatted and consistent across answers.
                            </p>

                            <img
                                src="/images/well_formated_examples.png"
                                alt="SMMILE example problem"
                                style={{maxWidth: '900px', width: '100%'}}
                            />

                            <h2 style={{fontWeight: 'bold', marginTop: '20px'}}>New Hints on Problem Creation</h2>
                            <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                1. In a given problem, the examples should be about the same or similar question (or
                                task) of interest. For example, multiple times the question "Is there anisocoria?", each
                                with a different image.
                                <br/>
                                2. For a given problem, make the context examples diverse to challenge the model more
                                effectively.
                                <br/>
                                3. If your problem is a classification problem (e.g., pneumothorax vs pneumonia vs
                                normal), the problem becomes more useful if each class has a support of ≥ 2 examples.
                            </p>
                        </>
                    </div>
                    {/*<div>*/}
                    {/*    /!*{tutorial_video}*!/*/}

                    {/*</div>*/}
                    <Text>
                        <b>Enter your username. Every time you access the app, please enter the same username.</b>
                        <Input type="text" placeholder="Enter your username" value={username}
                               onChange={(e) => setUsername(e.target.value)}
                               style={{marginBottom: '10px', marginTop: '10px'}}/>
                    </Text>
                    <Button type="primary" htmlType="submit">Start</Button>
                </form>
            ) : (
                <>
                    {isBackendLoading && (
                        <div style={loadingOverlayStyle}>
                            <Spin tip="Loading..."/>
                        </div>
                    )}
                    <Alert
                        message="You found a bug or the plateform could be improved: email me at jbdel@stanford.edu  "
                        type="warning" closeText="Close Now" style={{width: '100%', marginBottom: 10}} showIcon/>
                    <Space direction="vertical" style={{width: 900}}>
                        <>
                            <Space direction={"horizontal"} style={{float: 'right'}}>
                                {/*<Button icon={<PlaySquareOutlined/>} type="primary"*/}
                                {/*        onClick={() => setopenModalTutorial(true)}>Show*/}
                                {/*    Tutorial</Button>*/}
                                <Button icon={<FilePdfOutlined/>} type="primary"
                                        onClick={() => setopenModalInstruction(true)}>Show
                                    Instructions</Button>
                            </Space>
                            <Modal
                                title="Tutorial"
                                centered
                                open={openModalTutorial}
                                onOk={() => setopenModalTutorial(false)}
                                onCancel={() => setopenModalTutorial(false)}
                                width={1000}
                            >
                                <div align={"center"}>
                                    {tutorial_video}
                                </div>
                            </Modal>
                            <Modal
                                title="Validating problem"
                                centered
                                open={openModalValidation}
                                width={"100%"}
                                footer={[
                                    <Button key="back" onClick={() => setopenModalValidation(false)}>
                                        Return
                                    </Button>,
                                    <Button key="submit" type="primary" onClick={handleSubmit}>
                                        Yes, submit
                                    </Button>,
                                ]}
                            >
                                <div align={"center"}>
                                    <h2>Does this problem look good?</h2>
                                    <Row justify="space-evenly">
                                        {panels.map((item, index) => (
                                            <Col span={2} key={item.key}>
                                                <Card
                                                    title={`${index === panels.length - 1 ? 'Final Problem' : `Example ${index + 1}`}`}
                                                    hoverable
                                                    bordered={true}
                                                    cover={<img src={decodeURIComponent(item.url)}
                                                                alt={`Example ${index + 1}`}
                                                                style={{maxWidth: "100%", maxHeight: 150}}/>}
                                                    style={{width: 240, height: 400}}
                                                >
                                                    <div style={{
                                                        fontSize: 16,
                                                        fontWeight: 500,
                                                        paddingBottom: 10
                                                    }}>{item.question}</div>
                                                    <div style={{color: "grey"}}>
                                                        Answer: {item.answer}<br/>
                                                    </div>
                                                    <p></p>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </Modal>
                            <Modal
                                title="Instructions"
                                centered
                                open={openModelInstruction}
                                onOk={() => setopenModalInstruction(false)}
                                onCancel={() => setopenModalInstruction(false)}
                                width={1000}
                            >
                                <>
                                    <h1 style={{marginBottom: '10px', fontWeight: 500, fontSize: '34px'}}>
                                        Stanford Multimodal Medical In-context Learning benchmark (😊SMMILE)
                                    </h1>

                                    <p style={{marginBottom: '16px'}}>
                                        <strong>Contact:</strong> Michael Moor, MD PhD (mdmoor@cs.stanford.edu),
                                        Jean-Benoit
                                        Delbrouck, PhD (jbdel@stanford.edu)
                                    </p>

                                    <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                        We're excited that you are participating in this Stanford CS / AIMI research
                                        project
                                        to create a medical visual question-answering (VQA) benchmark for multimodal AI
                                        models! We focus on challenging
                                        tasks for which we provide a model with few multimodal context examples, to be
                                        followed by a final problem (see
                                        below in the visual examples) which on its own is not easy to solve for existing
                                        vision-language models (i.e.,
                                        those of us with access can check with GPT4-V).
                                    </p>

                                    <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                        <strong>Topics:</strong> The problems can range across all medical specialties,
                                        including
                                        radiology images, photographs, pathology slices, ophthalmology imaging etc. Try
                                        to focus mostly on 2D images (e.g.,
                                        slice of CT, Chest X-ray, Photograph etc.), but links to further modalities are
                                        welcome (audio, video,
                                        sequencing etc.) - as long as they can be referred to via URL.
                                    </p>

                                    <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                        <strong>Data:</strong> Do NOT upload any media (e.g., images, videos, audio).
                                        Instead, please
                                        provide a URL (link) to a publicly available media resource. Do not display any
                                        identifiable patient
                                        information.
                                    </p>

                                    <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                        <strong>Guidelines:</strong> Try to follow a consistent answer format within a
                                        given problem - if
                                        the problem allows for it. Most importantly, answers must follow a consistent
                                        format: "Epidural hematoma,
                                        left.", "Subdural hematoma, right." etc. <strong>Two in-context examples minimum
                                        - 10
                                        maximum.</strong>
                                    </p>

                                    <h2 style={{fontWeight: 'bold', marginTop: '20px'}}>Example Problems</h2>
                                    <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                        Here are four examples of how the in-context learning problems can look. These
                                        problems are considered well formatted and consistent across answers.
                                    </p>

                                    <img
                                        src="/images/well_formated_examples.png"
                                        alt="SMMILE example problem"
                                        style={{maxWidth: '900px', width: '100%'}}
                                    />

                                    <h2 style={{fontWeight: 'bold', marginTop: '20px'}}>New Hints on Problem
                                        Creation</h2>
                                    <p style={{marginBottom: '16px', lineHeight: '1.6'}}>
                                        1. In a given problem, the examples should be about the same or similar question
                                        (or task) of interest. For example, multiple times the question "Is there
                                        anisocoria?", each with a different image.
                                        <br/>
                                        2. For a given problem, make the context examples diverse to challenge the model
                                        more effectively.
                                        <br/>
                                        3. If your problem is a classification problem (e.g., pneumothorax vs pneumonia
                                        vs normal), the problem becomes more useful if each class has a support of ≥ 2
                                        examples.
                                    </p>
                                </>
                            </Modal>
                        </>
                        <Typography>
                            <Title style={{marginBottom: '20px', fontWeight: 900, fontSize: '68px'}}>SMMILE</Title>
                            <Form form={formSpecialty}>
                                <Form.Item
                                    label="Medical specialty of this problem:"
                                    name="medical_speciality"
                                    rules={[{required: true}]}
                                >
                                    <Select placeholder="Click for dropdown"
                                            onChange={handleSpecialtyChange}
                                            style={{marginBottom: 20}}
                                            value={selectedSpecialty}
                                    >
                                        <Option value="radiology">Radiology</Option>
                                        <Option value="pathology">Pathology</Option>
                                        <Option value="dermatology">Dermatology</Option>
                                        <Option value="surgery">Surgery</Option>
                                        <Option value="ophthalmology">Ophthalmology</Option>
                                        <Option value="other">Other</Option>
                                    </Select>
                                </Form.Item>
                            </Form>

                            <Collapse activeKey={activePanelKeys} onChange={setActivePanelKeys}>
                                {panels.map((panel, index) => (
                                    <Panel
                                        header={
                                            <strong style={{textDecoration: 'underline'}}>
                                                {(index === panels.length - 1 && index !== 0) ? "Final Problem" : `Example ${index + 1}`}
                                            </strong>
                                        }
                                        key={panel.key}
                                    >
                                        <Space direction="horizontal" style={{width: '100%'}}>
                                            <Space direction="vertical" style={{width: '100%'}} size={0}>
                                                {/*<Upload*/}
                                                {/*    name="avatar"*/}
                                                {/*    listType="picture-card"*/}
                                                {/*    showUploadList={false}*/}
                                                {/*    beforeUpload={beforeUpload}*/}
                                                {/*    onChange={(info) => handleUploadChange(info, index)}*/}
                                                {/*    accept=".jpg,.jpeg,.png"*/}
                                                {/*    onPreview={() => {*/}
                                                {/*    }}*/}
                                                {/*>*/}
                                                {/*    {panel.base64_string ? (*/}
                                                {/*        <img src={panel.base64_string} alt="avatar"*/}
                                                {/*             style={{width: '100%', marginBottom: 8, maxHeight: '100%'}}/>*/}
                                                {/*    ) : (*/}
                                                {/*        uploadButton(panel.loading)*/}
                                                {/*    )}*/}
                                                {/*</Upload>*/}
                                                {/*{panel.base64_string &&*/}
                                                {/*    <div style={{display: 'flex'}}>*/}
                                                {/*        <Button size="small" icon={<EyeOutlined/>}*/}
                                                {/*                onClick={() => handlePreviewImage(panel.base64_string)}/>*/}
                                                {/*        <Button size="small" icon={<DeleteOutlined/>}*/}
                                                {/*                onClick={() => handleDeleteImage(index)}/>*/}
                                                {/*    </div>*/}
                                                {/*}*/}
                                                <Image
                                                    width={300}
                                                    height={300}
                                                    src={panel.base64_string ? panel.base64_string : ""}
                                                    fallback="data:image/png;base64,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"
                                                />
                                            </Space>
                                            <Form
                                                key={panel.formKey} // Assuming formKey changes trigger re-render
                                                name={`panel_form_${panel.key}`}
                                                layout="vertical"
                                                initialValues={{
                                                    question: panel.question,
                                                    answer: panel.answer,
                                                    url: panel.url,
                                                }} // Set to the state values
                                                style={{width: 500}}
                                            >
                                                <Form.Item
                                                    label="URL"
                                                    name="url"
                                                    rules={[{required: true}]}
                                                >
                                                    <Input value={panel.url}
                                                           onChange={(e) => updateFieldURL(index, 'url', e.target.value)}/>
                                                </Form.Item>

                                                <Form.Item
                                                    label="Question"
                                                    name="question"
                                                    rules={[{required: true}]}
                                                >
                                                    <Input value={panel.question}
                                                           onChange={(e) => updateField(index, 'question', e.target.value)}/>
                                                </Form.Item>

                                                <Form.Item
                                                    label="Answer"
                                                    name="answer"
                                                    rules={[{required: true}]}
                                                >
                                                    <TextArea rows={4} value={panel.answer}
                                                              onChange={(e) => updateField(index, 'answer', e.target.value)}/>
                                                </Form.Item>
                                            </Form>
                                        </Space>
                                        <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 8}}>
                                            <Space>
                                                <Button type="danger" onClick={() => handleDeletePanel(panel.key)}>Delete
                                                    Panel</Button>
                                                {index > 0 && (
                                                    <Button icon={<ArrowUpOutlined/>}
                                                            onClick={() => movePanelUp(panel.key)}>Up</Button>
                                                )}
                                                {index < panels.length - 1 && (
                                                    <Button icon={<ArrowDownOutlined/>}
                                                            onClick={() => movePanelDown(panel.key)}>Down</Button>
                                                )}
                                            </Space>
                                        </div>
                                    </Panel>
                                ))}
                            </Collapse>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '16px',
                                alignItems: 'center',
                                paddingBottom: 50
                            }}>
                                <Button type="danger" onClick={handleReset}>Reset</Button> {/* Reset Button */}
                                <Space>
                                    <Button type="primary" onClick={addPanel}>Add Panel</Button>
                                    <Button type="primary" onClick={handleSubmitPre}>Submit</Button>
                                </Space>
                            </div>
                        </Typography>
                        <Modal open={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
                            <img alt="preview" style={{width: '100%'}} src={previewImage}/>
                        </Modal>
                        <Modal
                            title={
                                <>
                                    <CheckCircleTwoTone twoToneColor="#52c41a"/> Problem successfully created
                                </>
                            }
                            centered
                            open={openModalSuccess}
                            onOk={() => setOpenModalSuccess(false)}
                            footer={[
                                <Button key="submit" type="primary" onClick={() => {
                                    handleReset();
                                    history.replace({ pathname: location.pathname });
                                    setOpenModalSuccess(false);
                                }}>
                                    Start a new problem
                                </Button>,
                                <Button key="back" onClick={() => setOpenModalSuccess(false)}>
                                    Keep current problem
                                </Button>,
                            ]}

                            width={500}
                        >
                            What would you like to do next?
                        </Modal>
                    </Space>
                </>
            )}
        </div>
    );
};

export default SMMILE;
